import { useDataProvider, useGetIdentity, usePermissions } from "ra-core";
import { useContext, useMemo } from "react";
import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";
import { dataProviderStore } from "../../dialer/api/recordStore";
import { IS_DEMO } from "../../env";
import { createFakeTrainingApi } from "./fakeTrainingApi";
import { createSupabaseTrainingApi } from "./supabaseTrainingApi";
import { TrainingApiContext } from "./trainingApiContextValue";
import type { TrainingApi } from "./types";

/**
 * The injected API, else the FakeRest twin in the demo build (it reads the demo's own tables) or the Supabase RPCs.
 * Null until the identity is known.
 */
export function useTrainingApi(): TrainingApi | null {
  const injected = useContext(TrainingApiContext);
  const dataProvider = useDataProvider();
  const { identity } = useGetIdentity();
  const { permissions } = usePermissions();
  const me = identity?.id;
  const isAdmin = permissions === "admin";
  return useMemo(() => {
    if (injected) return injected;
    if (me === undefined || me === null) return null;
    return IS_DEMO
      ? createFakeTrainingApi({
          store: dataProviderStore(dataProvider),
          me: Number(me),
          isAdmin,
        })
      : createSupabaseTrainingApi(getSupabaseClient);
  }, [injected, me, isAdmin, dataProvider]);
}
